// utils/themeUtils.js
export const toggleTheme = () => {
  const html = document.documentElement;
  const isDark = html.classList.contains("dark");
  
  if (isDark) {
    // Switching to light mode
    html.classList.remove("dark");
    localStorage.setItem("theme", "light");
  } else {
    // Switching to dark mode
    html.classList.add("dark");
    localStorage.setItem("theme", "dark");
  }
  
  return !isDark; // Return new state
};

export const initializeTheme = () => {
  // Check if theme preference exists in localStorage
  const savedTheme = localStorage.getItem("theme");
  
  if (savedTheme) {
    // Apply saved theme
    if (savedTheme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  } else {
    // If no theme exists, check system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (prefersDark) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      localStorage.setItem("theme", "light");
    }
  }
};

export const getCurrentTheme = () => {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
};